import React from "react";
import Navbar from "./home/Navbar";
import Footer from "../components/Footer";
import ScrollToTop from "./ScrollToTop";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main><Outlet /></main>
      <Footer />
    </>
  );
};

export default Layout;
